import React from 'react';
import { extract } from '@10d/tend-ui-utils';
import { ru } from '../messages/ru.js';
import { en } from '../messages/en.js';
import { useLanguage } from './useLanguage.js';

const useTranslation = () => {
    const lang = useLanguage('useTranslation');
    const schema = { ru, en }[lang];
    return React.useCallback((path) => extract(schema, path), [schema]);
};

export { useTranslation };
//# sourceMappingURL=useTranslation.js.map
